import React from 'react';

const MicrophoneIcon = ({ className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={`text-v3-black-secondary ${className}`}
      {...props}
    >
      <path 
        d="M7 8C7 6.67392 7.52678 5.40215 8.46447 4.46447C9.40215 3.52678 10.6739 3 12 3C13.3261 3 14.5979 3.52678 15.5355 4.46447C16.4732 5.40215 17 6.67392 17 8V11C17 12.3261 16.4732 13.5979 15.5355 14.5355C14.5979 15.4732 13.3261 16 12 16C10.6739 16 9.40215 15.4732 8.46447 14.5355C7.52678 13.5979 7 12.3261 7 11V8Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M13 8H17M13 11H17M20 10V11C20 13.1217 19.1571 15.1566 17.6569 16.6569C16.1566 18.1571 14.1217 19 12 19M12 19C9.87827 19 7.84344 18.1571 6.34315 16.6569C4.84285 15.1566 4 13.1217 4 11V10M12 19V22" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default MicrophoneIcon;
